export default (string, length, ellipsis = true, start = 0) => {
    let shortenedString = string.substring(start, length + start)

    if(string.length > length && ellipsis) {
        shortenedString += '...'
    }

    return shortenedString
}